import React from 'react'
import { useNavigate } from "react-router-dom";

export default function Programs() {



    let navigate = useNavigate();

    const openProgram = (id) => {
        navigate(`/programdetail/${id}`);
    };

    const programsData = [
        {
            id: 1,
            title: "Mental Health Awareness Workshop",
            image: "Content/img/slide/BNT9.jpg",
            date: "2024-03-12"
        },
        {
            id: 2,
            title: "Youth Empowerment Program",
            image: "Content/img/slide.jpg",
            date: "2024-02-20"
        },
        {
            id: 3,
            title: "Community Support Meetup",
            image: "Content/img/NewBNT192.jpg",
            date: "2024-01-10"
        },
        {
            id: 4,
            title: "Seniors Wellness Session",
            image: "Content/img/slide/BNT9.jpg",
            date: "2023-12-05"
        },
        {
            id: 5,
            title: "Anti-Racism Awareness Drive",
            image: "Content/img/slide.jpg",
            date: "2023-11-18"
        }
    ];
    return (
        <>
            <div className="hero page-inner overlay"
                style={{ backgroundImage: `url('../../Content/img/slide/BNT5.jpg')` }}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-9 text-center mt-5">
                            <h1 className="heading" data-aos="fade-up">Programs</h1>
                            <nav aria-label="breadcrumb"
                                data-aos="fade-up"
                                data-aos-delay="200">
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container py-5">
                <div className="row justify-content-center text-center mb-4">
                    <div className="col-lg-6">
                        <h2 className="font-weight-bold heading text-primary">
                            Our Programs
                        </h2>
                        <h6 className="text-secondary">
                            A look at our past initiatives
                        </h6>
                    </div>
                </div>

                <div className="row">
                    {programsData.map((item) => {
                        const dateObj = new Date(item.date);
                        const day = dateObj.getDate();
                        const month = dateObj.toLocaleString('en-US', { month: 'short' });
                        const year = dateObj.getFullYear();

                        return (
                            <div className="col-12 col-md-6 col-lg-4 mb-4" key={item.id}>
                                <div className="programCard" onClick={() => openProgram(item.id)}>

                                    <div
                                        className="programImg"
                                        style={{ backgroundImage: `url(${item.image})` }}
                                    >
                                        <div className="programDate">
                                            <span>{day}</span>
                                            <p>{month}</p>
                                            <small>{year}</small>
                                        </div>
                                    </div>

                                    <div className="programContent">
                                        <h5>{item.title}</h5>
                                    </div>

                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

        </>
    )
}
